export const LicenseHardwareLandingPageTemplate = {
    slots: ['SlbCheckoutContainerSlot'],
};